import { useEffect, useState } from 'react';
import { ProgressBar } from '@taxdown/piccolo-web';
import * as Styled from '../styles';

const Progress = (): JSX.Element => {
  const [progress, setProgress] = useState<number>(10);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setProgress(prevProgress => {
        if (prevProgress < 90) {
          return prevProgress + 10;
        }
        clearInterval(intervalId);
        return 90;
      });
    }, 5000);

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  return (
    <Styled.ProgressContainer>
      <ProgressBar filled={progress} baseColor="" filledColor="" />
    </Styled.ProgressContainer>
  );
};

export default Progress;
